import { required, minValue } from 'vuelidate/lib/validators'

const mixin = {
  // variavel "produto" deve existir no componente onde este mixin for usado
  validations: {
    produto: {
      cobertura_estoque: {
        required,
        minValue: minValue(0),
      },
      estoque_min: {
        required,
        minValue: minValue(0),
        // quantidade() {
        //   return parseFloat(this.produto.estoque_min) <= parseFloat(this.produto.estoque_max)
        // }
      },
      estoque_max: {
        required,
        minValue: minValue(0),
        // quantidade() {
        //   return parseFloat(this.produto.estoque_max) >= parseFloat(this.produto.estoque_min)
        // }
      },
      multiplo_dist: {
        required,
        minValue: minValue(1),
      }
    }
  },
  computed: {
    coberturaEstoqueErrors() {
      const errors = [];
      if (!this.$v.produto.cobertura_estoque.$dirty) return errors;
      !this.$v.produto.cobertura_estoque.required && errors.push("O valor é obrigatório.");
      !this.$v.produto.cobertura_estoque.minValue && errors.push("Valor mínimo é 0.");
      return errors;
    },
    estoqueMinErrors() {
      const errors = [];
      if (!this.$v.produto.estoque_min.$dirty) return errors;
      !this.$v.produto.estoque_min.required && errors.push("O valor é obrigatório.");
      !this.$v.produto.estoque_min.minValue && errors.push("Valor mínimo é 0.");
      // !this.$v.produto.estoque_min.quantidade && errors.push("Valor mínimo deve ser menor que o valor máximo.");
      return errors;
    },
    estoqueMaxErrors() {
      const errors = [];
      if (!this.$v.produto.estoque_max.$dirty) return errors;
      !this.$v.produto.estoque_max.required && errors.push("O valor é obrigatório.");
      !this.$v.produto.estoque_max.minValue && errors.push("Valor mínimo é 0.");
      // !this.$v.produto.estoque_max.quantidade && errors.push("Valor máximo deve ser maior que o valor mínimo.");
      return errors;
    },
    multiploDistribuicaoErrors() {
      const errors = [];
      if (!this.$v.produto.multiplo_dist.$dirty) return errors;
      !this.$v.produto.multiplo_dist.required && errors.push("O valor é obrigatório.");
      !this.$v.produto.multiplo_dist.minValue && errors.push("Valor mínimo é 1.");
      return errors;
    },
  },
}

export default mixin
